import { Component, OnInit, Input, ViewChild, EventEmitter, Output,OnChanges, AfterContentInit, OnDestroy } from '@angular/core';
import { Table, TableModule } from 'primeng/table';
import { GridService } from 'app/Shared/Services/grid.service';
import {default as CAT_MECO} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MECO.json';
import {default as CAT_MECOC}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MECOC.json';
import {default as CAT_MECOM}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MECOM.json';
import {default as CAT_MEFA } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEFA.json';
import {default as CAT_MEIR } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEIR.json';
import {default as CAT_MENO } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MENO.json';
import {default as CAT_MENOS}  from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MENOS.json';
import {default as CAT_MENQ } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MENQ.json';
import {default as CAT_MEOA } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOA.json';
import {default as CAT_MEOC } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOC.json';
import {default as CAT_MEOF} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOF.json';
import {default as CAT_MEOJ} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOJ.json';
import {default as CAT_MEOM} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOM.json';
import {default as CAT_MEOMS} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOMS.json';
import {default as CAT_MEOR} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOR.json';
import {default as CAT_MEOT} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEOT.json';
import {default as CAT_MEQC} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEQC.json';
import {default as CAT_MEQR} from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MEQR.json';
import {default as EventType_DS} from 'app/Shared/Constant/Client_Event_Type_Grid_JSON/Client_Exception_Edit-EventType-DS.json';
import {default as EventType_EX} from 'app/Shared/Constant/Client_Event_Type_Grid_JSON/Client_Exception_Edit-EventType-EX.json';
import {default as EventType_OR} from 'app/Shared/Constant/Client_Event_Type_Grid_JSON/Client_Exception_Edit-EventType-OR.json';
import {default as EventType_OE} from 'app/Shared/Constant/Client_Event_Type_Grid_JSON/Client_Exception_Edit-EventType-OE.json';
import {default as EventType_NW} from 'app/Shared/Constant/Client_Event_Type_Grid_JSON/Client_Exception_Edit-EventType-NW.json';
import {default as EventType_CL} from 'app/Shared/Constant/Client_Event_Type_Grid_JSON/Client_Exception_Edit-EventType-CL.json';
import {default as EventType_CR} from 'app/Shared/Constant/Client_Event_Type_Grid_JSON/Client_Exception_Edit-EventType-CR.json';
import {default as EventType_RT} from 'app/Shared/Constant/Client_Event_Type_Grid_JSON/Client_Exception_Edit-EventType-RT.json';
import {default as _} from 'lodash';

import { EmitterService } from 'app/Shared/Services/emitter.service';
import { UserService } from 'app/Shared/Services/user.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import {Router} from "@angular/router";
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { ButtonModule } from 'primeng/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QuickviewSidebarComponent } from 'app/Shared/Component/quickview-sidebar/quickview-sidebar.component';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ContextMenuModule, ContextMenu } from 'primeng/contextmenu';
import { GridCommonService } from 'app/Shared/Services/grid-common.service';

@Component({
    selector: 'app-grid',
    imports: [TableModule,CommonModule,FormsModule,
        ButtonModule, MatTooltipModule, QuickviewSidebarComponent, ExportToCSVSComponent,ContextMenuModule],
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.scss']
})

export class GridComponent implements OnInit,OnChanges, AfterContentInit, OnDestroy {
  @ViewChild(('dt')) dt!: Table | any;
  @ViewChild('cm') contextMenuItems!: ContextMenu;
  @Input() GridColumns: any;
  @Input() OptedExportCSVGridColumns: any = [];
  @Input('Dataset') Dataset: any = [];
  @Input('PageName') PageName: any="";
  @Input('TotalRecords') totalRecords: any = [];
  @Input('totalRecords') TotalRecords: any = [];
  @Input('isResetlimit') isResetlimit: any = [];
  @Input('SymbolFilter') SymbolFilter: any;
  @Input('isExportEnabled') isExportEnabled: boolean = true;
  @Input('displayTildCount') displayTildCount: boolean = false;

  
  @Output() RestSymbolEvent: EventEmitter<any> = new EventEmitter();
  @Output() RestLimitEvent: EventEmitter<any> = new EventEmitter();
  @Output() exportData: EventEmitter<any> = new EventEmitter();
  DefaultFilterArray:any=[];
  selectedRowData: any = [];
  quickviewcols: any = [];
  selectedRow: any = [];
  cols: any = [];
  Data: any = [];
  rowcount: any = "10";
  rowsPerPageOptions: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 100];
  RecordCount!: number;
  priviousStartLimit: any = 0;
  first: number = 0;
  pageNumber: number = 1;
  priviousRowCount: any = 0;
  startLimit: any = 0;
  endLimit: any;
  Symbolvalue: any;
  tbldatamsg: any = "No Records Found"
  EventType: any;
  isQuickViewOpenClose: boolean = false;
  isOrderViewerOpenClose: boolean = false;
  subscription!: Subscription;
  sortData:any = { field: '', order: 0};
  sortClickCounter: number = 0;
  defaultData: any;
  
  constructor(
    private gridService: GridService,
    private emitterService: EmitterService,
    private userService:UserService,
    private router: Router,
    public sortPipe: SortPipe,
    private messageService: MessageService,
    public constantService:ConstantService,
    public commonColService:GridCommonService) {
  }

  ngOnInit() {
    this.addGridColumn();
    this.rowcount = this.gridService.getGridRowsCount();
    this.endLimit = this.rowcount;
    this.totalRecords = this.rowcount;
    this.priviousRowCount = this.rowcount;
    this.Data = this.Dataset;
   
    this.subscription = this.emitterService.isResetGridLimit.subscribe(event => {
      if (event) {
        this.resetGridLimit();
      }
    });
    this.commonColService.init(this.cols, this.PageName);
  }
  ngOnChanges(){
    this.defaultData = this.Dataset;
  }

  OrderViewerCloseEvent(event: any) {
    this.selectedRow = [];
    this.quickviewcols = [];
    this.isOrderViewerOpenClose = false;
  }

  QuickViewCloseEvent(event: any) {
    this.selectedRow = [];
    this.quickviewcols = [];
    this.isQuickViewOpenClose = false;
  }

  addGridColumn() {
    let column: any = this.GridColumns;
    this.cols = this.gridService.getGridColumns(column)
  }

  ngAfterContentInit() {
  }

  gethighLightedCellClass(row:any, col:any) {
    return (this.PageName==='System-Monitoring' && ((row['Process_Remark'].toLocaleLowerCase().indexOf('error')>=0 && row['Process_Remark'].toLocaleLowerCase().indexOf('.error')<0 && row['Process_Remark'].toLocaleLowerCase().indexOf('error.')<0) || row['Process_Remark'].toLocaleLowerCase().indexOf('fail')>=0 || row['Process_Remark'].toLocaleLowerCase().indexOf('not found')>=0) && row['Success_Flag'].toLocaleLowerCase()==='n' && col.value==='StartDtTm') || 
           (this.PageName==='ODR-System-Monitoring' && ((row['processRemark'].toLocaleLowerCase().indexOf('error')>=0 && row['processRemark'].toLocaleLowerCase().indexOf('.error')<0 && row['processRemark'].toLocaleLowerCase().indexOf('error.')<0) || row['processRemark'].toLocaleLowerCase().indexOf('fail')>=0 || row['processRemark'].toLocaleLowerCase().indexOf('not found')>=0) && row['successFlag'].toLocaleLowerCase()==='n' && col.value==='startTime');
  }

  /****Custome ColumnFilter Function */
  ColumnFilter(dt:any, value:any, field:any, matchMode:string) {
    this.dt.filter(value, field, matchMode);
  }

  resetGridLimit() {
    this.startLimit = 0;
    this.endLimit = this.rowcount;
    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.dt.rows = this.rowcount;
  }

  checkSymbolFilter(value:any, field:any, pattern:any) {
    this.dt.filter(value, field, pattern);
    let inputlen: any = value;
    let symbol: any = this.Symbolvalue;
    if (inputlen == '' || inputlen.length < symbol.length) {
      this.RestSymbolEvent.emit(true);
    }
  }

  changePage(event:any) {
    this.startLimit = event.first;
    this.rowcount = event.rows;
    this.endLimit = this.startLimit + this.rowcount;
    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    if (this.priviousStartLimit != this.startLimit) {
      this.RestLimitEvent.emit({ 'Start': this.startLimit, 'End': this.rowcount });
      this.priviousStartLimit = this.startLimit;
      this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    }
    if (this.priviousRowCount != this.rowcount) {
      this.RestLimitEvent.emit({ 'Start': event.first, 'End': this.rowcount });
      this.priviousRowCount = this.rowcount;
    }
  }

  onRowSelect(type: any, rowData:any) {
    this.selectedRow = [];
    this.selectedRowData[0] = (rowData);
    this.selectedRow[0] = (rowData);
    if (type == 'View') {
      this.prepareQuickviewPanel();
      this.isQuickViewOpenClose = true;
    }
    if (type == 'OrderID') {
       this.emitterService.isOrderViewerOpenCloseEvent.emit({
          display: true,
          rowData: rowData,
          pageName: this.PageName
        });
    }
  }

  prepareQuickviewPanel() {
    this.quickviewcols = [];
    let temp: any = this.selectedRow[0];
    let columns = [];
    this.EventType = '';
    this.EventType = temp['type']


    switch (this.EventType.toLocaleUpperCase()) {
      case 'MECO':
        this.quickviewcols = CAT_MECO;
        break;
      case 'MECOC':
        this.quickviewcols = CAT_MECOC;
        break;
      case 'MECOM':
        this.quickviewcols = CAT_MECOM;
        break;
      // case 'MECQ':
      //   this.quickviewcols = CAT_MECQ;
      //   break;
      case 'MEFA':
        this.quickviewcols = CAT_MEFA;
        break;
      case 'MEIR':
        this.quickviewcols = CAT_MEIR;
        break;
      // case 'MEJO':
      //   this.quickviewcols = CAT_MEJO;
      //   break;
      case 'MENO':
        this.quickviewcols = CAT_MENO;
        break;
      case 'MENOS':
        this.quickviewcols = CAT_MENOS;
        break;
      case 'MENQ':
        this.quickviewcols = CAT_MENQ;
        break;
      case 'MEOA':
        this.quickviewcols = CAT_MEOA;
        break;
      case 'MEOC':
        this.quickviewcols = CAT_MEOC;
        break;
      case 'MEOF':
        this.quickviewcols = CAT_MEOF;
        break;
      case 'MEOJ':
        this.quickviewcols = CAT_MEOJ;
        break;
      case 'MEOM':
        this.quickviewcols = CAT_MEOM;
        break;
      case 'MEOMS':
        this.quickviewcols = CAT_MEOMS;
        break;
      case 'MEOR':
        this.quickviewcols = CAT_MEOR;
        break;
      case 'MEOT':
        this.quickviewcols = CAT_MEOT;
        break;
      // case 'MEOTQ':
      //   this.quickviewcols = CAT_MEOTQ;
      //   break;
      case 'MEQC':
        this.quickviewcols = CAT_MEQC;
        break;
      case 'MEQR':
        this.quickviewcols = CAT_MEQR;
        break;
      case 'EX':
        this.quickviewcols = EventType_EX;
        break;
      case 'CL':
        this.quickviewcols = EventType_CL;
        break;
      case 'CR':
        this.quickviewcols = EventType_CR;
        break;
      case 'DS':
        this.quickviewcols = EventType_DS;
        break;
      case 'NW':
        this.quickviewcols = EventType_NW;
        break;
      case 'OE':
        this.quickviewcols = EventType_OE;
        break;
      case 'OR':
        this.quickviewcols = EventType_OR;
        break;
      case 'RT':
        this.quickviewcols = EventType_RT;
        break;
      default: {
        //statements; 
        break;
      }
    }

  }

  exportToCSV(event:any) {
    if (event.isExportMaxRows) {
      this.exportData.emit({ 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS, 'event': event });
    } else {
      this.exportData.emit({ 'Start': this.startLimit, 'End': this.rowcount ,'event': event});
    }
  }
  sort(event:any) {
  if (this.commonColService.isCtrlPressed|| this.commonColService.isDragging || this.commonColService.selectedFields.length > 1) {
    this.dt.multiSortMeta =[];
    this.dt.sortField = '';
    this.dt.sortOrder = 0;
    return;
  }
    if(this.sortClickCounter !== 3 &&(this.sortData.field === "" ||this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    } 
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.Dataset = this.sortPipe.transform(this.Dataset, this.sortData.order, this.sortData.field);
    } else {
    this.resetSort();
    }
    
  }
  resetSort() {
    this.dt.multiSortMeta[0].field = '';
    this.dt.multiSortMeta[0].order = 0
    this.Dataset = this.defaultData;
   }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}


